import { MediaAdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import { transcriptPlayerKeys } from './transcriptPlayerKeys';

export const createFetchTranscriptAudioQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId }], signal }: QueryFunctionContext<ReturnType<typeof transcriptPlayerKeys.audio>>) =>
    call(() => cancelOnSignal(MediaAdminService.adminGetSignedUrl({ jobId, file: 'output.mp3' }), signal), {
      dontRedirectOnError: true,
      onError: () => {},
    });
